import { Link, useLocation } from 'react-router-dom';
import './productPage.css';
import { useContext, useEffect, useState } from 'react';
import { cartContext } from '../../App';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import HeaderOther from '../ui/header-other';
import ProductInfoCard from '../ui/productInfoCard';
import BottomCart from '../ui/bottom-cart';
import RequestProductCTA from '../ui/request-product-cta';

export default function ProductPage() {

    const { productDataList, clearAppliedCoupon } = useContext(cartContext);
    const [expandReturn, setExpandReturn] = useState(false);
    const [expandDisclaimer, setExpandDisclaimer] = useState(false);
    const [expandDesc, setExpandDesc] = useState(true)
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search); 
    const productId = queryParams.get('productId');
    const index = queryParams.get('index');

    const productData = productDataList.find((data) => data.id === productId)
    const product = productData.data
    const similarProducts = productDataList.filter((item) => item.data.category === product.category && item.data.title !== product.title)

    const url = 'https://www.freslo.in' + location.pathname + location.search

    const { CartItem, addToCart, removeFromCart, maxAmountReached , changeMaxAmountReached } = useContext(cartContext);

    function share() {

        if (navigator.share) {
            navigator.share({
                title: 'freslo (formerly OnTimeUrban) - Fast, Fresh & Local | Hazaribagh',
                text: 'Check out ' + product.title,
                url: url,
            })
        } else {
            alert('Sharing is not supported by browser.')
        }

    }

    function handleIncrement(index, data) {

        const currentItem = CartItem.find(productItem => productItem.id === data.id)
        // console.log("data title", data.title)
        if (currentItem) {
            const addData = {
                id: currentItem.id,
                details: currentItem.details,
                qty: currentItem.qty + 1
            }
            removeFromCart(addData);
            addToCart(addData)
        } else {
            const addData = {
                id: data.id,
                details: data.data,
                qty: 1
            }
            removeFromCart(addData);
            addToCart(addData)
        }
        clearAppliedCoupon();
        console.log('cart-items',CartItem)    
    }

    function handleDecrement(index, data) {
        const currentItem = CartItem.find(productItem => productItem.id === data.id)
        if (currentItem && currentItem.qty > 1) { 
            const addData = {
                id: currentItem.id,
                details: currentItem.details,
                qty: currentItem.qty - 1
            }
            removeFromCart(addData);
            addToCart(addData)
        } else {
            const addData = {
                id: currentItem.id,
                details: currentItem.details,
                qty: 0
            }
            removeFromCart(addData)
        }
        clearAppliedCoupon();
        
    }

    //handle maximum amount
    function handleMaximumAmount() {
        changeMaxAmountReached(true);
    }

    const settings = {
        dots: false, // Show navigation dots
        infinite: product.images.length > 1, // Infinite looping
        speed: 500, // Transition speed
        slidesToShow: Math.min(product.images.length, 1), // Number of slides visible
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Auto-slide
        autoplaySpeed: 3000, // Auto-slide speed in ms
        arrows: true, // Show navigation arrows
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [productId])

    const isDiscounted = Number(product.mrp) - Number(product.price) > 0 ? true : false;
    const discount = isDiscounted ? Math.round((Number(product.mrp) - Number(product.price)) / Number(product.mrp) * 100) : 0;
    return (
        <>
            {
                maxAmountReached && (
                    <div className="max-amount-reached">
                        <p className="max-amount-reached-text">Sorry, maximum amount reached</p>
                    </div>
                )
            }
            <HeaderOther title='Product Details' description='View item'/>
            <div className='page-container'>
                <div className="first-container">
                    <Slider {...settings}>
                        {
                            product.images.map((image, index) => (
                                <img key={index} className='product-pic' src={image} alt='product-pic'/>
                            ))
                        }
                    </Slider>
                    {
                        isDiscounted &&
                        <span className='discount-bar'>{discount}% OFF</span>
                    }
                    <img src='/icons/share2.png' alt='share-logo' className='share-bar' onClick={share}/>
                </div>
                <div className='last-container' style={{marginLeft:'7px', paddingTop:'5px', backgroundColor:'white', border:'none'}}>
                    <div className='title' style={{marginLeft:'5px'}}>{product.title}</div>
                    <p className='product-weight'>{product.weight}</p>
                    <div className='details'>
                        <div className='price'>
                            {
                                isDiscounted &&
                                <p className='price-tag'><span style={{fontFamily:'Arial'}}>&#8377;</span>{ product.mrp}</p>
                            }
                            <p className='actual-price'><span style={{fontFamily:'Arial'}}>&#8377;</span>{product.price}</p>
                        </div> 
                        {
                            product.quantity > 0 ? (
                                (() => {
                                    const matching = CartItem.find((datas) => datas.id === productData.id);
                                    return matching ? (
                                        <div className="qty-card-box">
                                            <button className="card-button-added" id={index} onClick={() => handleDecrement(index, productData)}>-</button>
                                            <span className="qty-item">{matching.qty}</span>
                                            {
                                                matching.qty >= product.quantity ?
                                                    <button className="card-button-added" id={index} style={{color:'gray'}} onClick={handleMaximumAmount}>+</button> :
                                                    <button className="card-button-added" id={index} onClick={() => handleIncrement(index, productData)}>+</button>
                                            }   
                                        </div>
                                    ) : (
                                        <button className="card-button" onClick={() => handleIncrement(index, productData)}>Add</button>
                                    );
                                })()
                            ) : (
                                <button className="card-button" style={{ backgroundColor: 'gray', color: 'white' }}>Sold</button>
                            )
                        }

                    </div>
                    <div className='returns-box' style={{marginTop: '10px'}}>
                        <div className='return-expand-box' onClick={() => setExpandDesc(!expandDesc)}>
                            <p className='return-text'>Product Description</p>
                            {
                                expandDesc ? 
                                    <p className='return-text'>&#9650;</p> :
                                    <p className='return-text'>&#9660;</p>
                            }
                        </div>
                        {
                            expandDesc && 
                            <div className='description'>
                                <ul style={{paddingLeft: '28px'}}>
                                    {
                                        product.description.split('.').map((desc, index) => (
                                            <div key={index}>
                                                {desc ? (
                                                    <li><p style={{margin:'5px', fontSize:'14px'}}>{ desc }.</p></li>
                                                ) : (
                                                    <p></p>
                                                )}
                                            </div>
                                        ))
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                    
                    <div className='trust-container'>
                        <div className='trust-box'>
                            <img src='/icons/product-return.png' alt='product return' className='trust-img'/>
                            <p className='trust-text'>1-Day Easy Returns</p>
                        </div>
                        <div className='trust-box'>
                            <img src='/icons/service.png' alt='product return' className='trust-img'/>
                            <p className='trust-text'>Premium Quality</p>
                        </div>
                        <div className='trust-box'>
                            <img src='/icons/trust.png' alt='product return' className='trust-img'/>
                            <p className='trust-text'>100% Trusted</p>
                        </div>
                    </div>

                    <div>
                        <div className='returns-box'>
                            <div className='return-expand-box' onClick={() => setExpandReturn(!expandReturn)}>
                                <p className='return-text'>Returns & Refund Policy</p>
                                {
                                    expandReturn ? 
                                        <p className='return-text'>&#9650;</p> :
                                        <p className='return-text'>&#9660;</p>
                                }
                            </div>
                            {
                                expandReturn && 
                                <div>
                                    <p className='return-detail-text'>To initiate a return, please go to the chat section and request a return.
                                        Items can be returned within 24 hours of delivery if they are damaged, defective,
                                        or incorrect. Perishable items like fruits and vegetables can only be returned if
                                        spoiled or damaged at the time of delivery.
                                    </p>
                                    <p className='return-detail-text'>
                                        Refunds: Refunds will be processed to the original payment method
                                        within 7 working days after the return is approved.
                                    </p>
                                </div>
                            }
                        </div>

                        <div className='returns-box' style={{marginTop: '10px'}}>
                            <div className='return-expand-box' onClick={() => setExpandDisclaimer(!expandDisclaimer)}>
                                <p className='return-text'>Disclaimer</p>
                                {
                                    expandDisclaimer ? 
                                        <p className='return-text'>&#9650;</p> :
                                        <p className='return-text'>&#9660;</p>
                                }
                            </div>
                            {
                                expandDisclaimer && 
                                <div>
                                    <p className='return-detail-text'>
                                        Product Information: freslo (formerly OnTimeUrban) strives to provide accurate product descriptions, images, and pricing.
                                        However, we do not guarantee that all product details are error-free, and minor variations may occur.
                                    </p>
                                    <p className='return-detail-text'>
                                        freslo (formerly OnTimeUrban) is not responsible for any adverse reactions resulting from the consumption of food, groceries,
                                        fruits, vegetables, or other perishable items. Customers are advised to check expiry dates, ingredients,
                                        packaging conditions, and freshness upon delivery. Fruits and vegetables should be thoroughly washed before consumption.
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="horizonatal-scroll" style={{marginBottom:'20px'}}>
                <div className="name-see-all">
                    <p className="tag-name">Similar Products</p>
                    <Link to='/display-products' state={{category:`${product.category}`, name:`Similar Products`}} className="see-all">See all&#62;</Link>
                </div>
                <div className="horizontal-list">
                    <ProductInfoCard dataList={similarProducts} />
                </div>
            </div>

            <RequestProductCTA />

            <BottomCart />
        </>
    );
}


